const vi = {
  100000001:'Thông tin chính',
  100000002:'Tên token',
  100000003:'Người tạo bản sao',
  100000004:'Thời gian tạo phiên bản',
  100000005:'Thông tin cơ bản',
  100000006:'Chuỗi khối/giao thức liên quan  ',
  100000007:'Địa chỉ hợp đồng thông minh  ',
  100000008:'Ngày phát hành',
  100000009:'Tổng cung',
  100000010:'Cung lưu hành',
  100000011:'Giá trị thị trường',
  100000012:'Thông tin',
  100000013:'Thông tin truyền thông xã hội',
  100000014:'Trang web',
  100000015:'White Paper',
  100000016:'Trình duyệt blockchain  ',
  100000017:'Đánh giá dự án',
  100000018:'Xếp hạng',
  100000019:'hàng đầu',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Đã cập nhật thời gian',
  100000027:'Đánh giá an toàn  ',
  100000028:'Đánh giá an toàn hợp đồng  ',
  100000029:'Thống kê dự án rủi ro  ',
  100000030:'Chi tiết mã hợp đồng  ',
  100000031:'Thuế mua  ',
  100000032:'Thuế bán  ',
  100000033:'Là bẫy mật  ',
  100000034:'Có thể mint lại  ',
  100000035:'Có danh sách đen  ',
  100000036:'Có danh sách trắng  ',
  100000037:'Có chống cá voi  ',
  100000038:'Có thể thay đổi thuế suất  ',
  100000039:'Mã nguồn mở  ',
  100000040:'Có chủ sở hữu ẩn  ',
  100000041:'Có thể tự hủy  ',
  100000042:'Là hợp đồng đại diện  ',
  100000043:'Có thể thay đổi số dư  ',
  100000044:'Có thể thực hiện cuộc gọi bên ngoài  ',
  100000045:'Có thể lấy lại quyền sở hữu  ',
  100000046:'Có thời gian chờ cho giao dịch  ',
  100000047:'Có thể tạm dừng chuyển khoản  ',
  100000048:'Quyền sở hữu không bị từ bỏ  ',
  100000049:'Là chống cá voi có thể điều chỉnh  ',
  100000050:'Quá nhiều chữ số thập phân  ',
  100000051:'Phương pháp Mint và Burn công khai  ',
  100000052:'Đốt token cập nhật tổng cung  ',
  100000053:'Đốt token cập nhật số dư   ',
  100000054:'Chuyển khoản cho chính mình làm tăng số dư  ',
  100000055:'Chuyển token vượt quá số dư sẽ bị vô hiệu  ',
  100000056:'Số dư không được cập nhật trong khi chuyển  ',
  100000057:'Sẽ tiêu tốn số dư của người nhận  ',
  100000058:'Gọi TransferFrom vượt quá số dư sẽ thất bại  ',
  100000059:'Phương pháp BurnFrom cập nhật tổng cung  ',
  100000060:'Xác định thuế mua của token. Trên 5% được coi là mức thuế cao',
  100000061:'Xác định thuế bán của token. Trên 5% được coi là mức thuế cao',
  100000062:'Kiểm tra xem token có phải là một trò lừa đảo honeypot không',
  100000063:'Kiểm tra xem có thể tạo thêm token không',
  100000064:'Kiểm tra xem token có danh sách đen hạn chế người dùng trao đổi hoặc chuyển token không',
  100000065:'Kiểm tra xem token có danh sách trắng cho phép địa chỉ bỏ qua mọi hạn chế không',
  100000066:'Kiểm tra xem token có cơ chế chống cá voi không',
  100000067:'Kiểm tra xem token có thuế và thuế có thể được sửa đổi bởi các vai trò đặc quyền không',
  100000068:'Kiểm tra xem token đã được xác minh trên trình khám phá blockchain chưa',
  100000069:'Kiểm tra xem token có chủ sở hữu ẩn có thể thao túng hợp đồng, ngay cả khi quyền sở hữu dường như đã bị từ bỏ không',
  100000070:'Kiểm tra xem token có thể tự hủy không',
  100000071:'Kiểm tra xem token có phải là hợp đồng ủy quyền chuyển tiếp các cuộc gọi chức năng đến một hợp đồng thực thi không',
  100000072:'Kiểm tra xem số dư token có thể được sửa đổi bởi các vai trò đặc quyền không',
  100000073:'Kiểm tra xem token có gọi các hợp đồng bên ngoài không',
  100000074:'Kiểm tra xem token có cửa hậu để lấy lại quyền sở hữu không',
  100000075:'Kiểm tra xem token có cơ chế thời gian chờ chuyển không',
  100000076:'Kiểm tra xem giao dịch token có thể bị tạm dừng bởi các vai trò đặc quyền không',
  100000077:'Kiểm tra xem quyền sở hữu đã bị từ bỏ chưa',
  100000078:'Kiểm tra xem cơ chế chống cá voi của token có thể được sửa đổi bởi các vai trò đặc quyền không',
  100000079:'Kiểm tra xem giá trị trả về của hàm decimals() có lớn hơn hoặc bằng 5 không',
  100000080:'Kiểm tra xem việc gọi các hàm mint() và burn() bởi người dùng ngẫu nhiên có bị từ chối không',
  100000081:'Kiểm tra xem việc gọi hàm burn() có cập nhật đúng totalSupply không',
  100000082:"Kiểm tra xem việc gọi hàm burnFrom() có cập nhật đúng hạn mức không",
  100000083:'Kiểm tra xem việc gọi hàm transfer() với người nhận giống như người gửi giao dịch có tăng số dư của người gửi không',
  100000084:'Kiểm tra xem việc gọi hàm transfer() với số lượng lớn hơn số dư có thất bại không',
  100000085:"Kiểm tra xem hạn mức của người chi tiêu có được cập nhật tương ứng sau khi gọi hàm transferFrom() không",
  100000086:"Kiểm tra xem việc gọi hàm transferFrom() có sử dụng số dư của người chi tiêu không",
  100000087:"Kiểm tra xem hạn mức có được cập nhật đúng sau khi gọi transferFrom(), hoặc giao dịch có bị hủy nếu số tiền không hợp lệ.",
  100000088:"Kiểm tra xem gọi hàm burnFrom() có cập nhật đúng totalSupply hay không.",
  100000089:'Kiểm tra xem quyền tạo token có tồn tại không',
  100000090:'Kiểm tra xem quyền đóng băng có tồn tại không',
  100000091:'Xem xét liệu siêu dữ liệu có thể được thay đổi không',
  100000092:'Nghiêm trọng',
  100000093:'Chính',
  100000094:'Trung bình',
  100000095:'Nhỏ',
  100000096:'Thông tin',
  100000097:'Quyền mint đã bị từ bỏ  ',
  100000098:'Quyền đóng băng đã bị từ bỏ  ',
  100000099:'Có thể thay đổi siêu dữ liệu của token  ',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default vi


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/vi.js